export const getAnalyte = (analyteId) => ({ analytes }) =>
analytes.analytesList.find(({ id }) => id === analyteId);